import { TextAlignPlugin } from '@platejs/basic-styles/react';
import { KEYS } from 'platejs';
import { useEditorState } from 'platejs/react';
import { type ComponentType, type CSSProperties, type MouseEvent } from 'react';

import AlignCenterIcon from '../../../../../icons/align-center.svg?react';
import AlignJustifyIcon from '../../../../../icons/align-justify.svg?react';
import AlignLeftIcon from '../../../../../icons/align-left.svg?react';
import AlignRightIcon from '../../../../../icons/align-right.svg?react';
import { ToolbarButton } from '../../ToolbarButton';

export const alignPlugin = TextAlignPlugin.configure({
  inject: {
    nodeProps: {
      defaultNodeValue: 'start',
      nodeKey: 'align',
      styleKey: 'textAlign',
      validNodeValues: ['start', 'left', 'center', 'right', 'end', 'justify'],
    },
    targetPlugins: [KEYS.p],
  },
});

const setBlockAlignment = (
  editor: ReturnType<typeof useEditorState>,
  align: CSSProperties['textAlign'],
) => {
  editor.tf.setNodes(
    { align },
    {
      match: (node) => !editor.api.isText(node),
      mode: 'lowest',
    },
  );
  editor.tf.focus();
};

const AlignButton = ({
  align,
  icon: Icon,
  label,
}: {
  align: CSSProperties['textAlign'];
  icon: ComponentType;
  label: string;
}) => {
  const editor = useEditorState();
  const active = !!editor.selection && editor.api.some({ match: { align } });

  return (
    <ToolbarButton
      active={active}
      tooltip={label}
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setBlockAlignment(editor, align);
      }}
    >
      <Icon />
    </ToolbarButton>
  );
};

export const AlignToolbarButtons = ({
  centerLabel = 'Align center',
  justifyLabel = 'Align justify',
  leftLabel = 'Align left',
  rightLabel = 'Align right',
}: {
  centerLabel?: string;
  justifyLabel?: string;
  leftLabel?: string;
  rightLabel?: string;
}) => (
  <>
    <AlignButton align="left" icon={AlignLeftIcon} label={leftLabel} />
    <AlignButton align="center" icon={AlignCenterIcon} label={centerLabel} />
    <AlignButton align="right" icon={AlignRightIcon} label={rightLabel} />
    <AlignButton align="justify" icon={AlignJustifyIcon} label={justifyLabel} />
  </>
);
